import React, {Component, PropType} from 'react'
var NoDataFoundCSS = {
    margin: '5% auto',
    textAlign: 'center',
    display:'inherit',
    heigh:"400px",
}

export default class NoDataFound extends React.Component{
    render(){ 
        var data = this.props.information ? this.props.information : this.props.data == '' || this.props.data == null ? "No Data Found": this.props.data;        
        let img = <img src="./assets/img/error2.jpg" className="img-fluid" alt="Error Page" />
        let style = 'tx-lg-20'

        if(this.props.hideImg) {
            img = null
            style = 'tx-lg-15'
            data = 'We could not load this component. Please reach out to your administrator for resolution.'
            if (this.props.status == -1 && this.props.information) {
                data = this.props.information
            } else if (this.props.is500) {
                if (this.props.response && this.props.response.dbError) {
                    data = this.props.error_message
                } else {
                    data = 'We are facing issues in the API. Please reach out to your administrator for resolution.'
                }
            } else if (this?.props?.information && this.props?.response?.status == false) {
                data = this?.props?.information
            }
            // data = this.props.status == -1 && this.props.information ? this.props.information : this.props.is500 ? 'We are facing issues in the API. Please reach out to your administrator for resolution.' : 'We could not load this component. Please reach out to your administrator for resolution.'
        }
        return (
            <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="wd-50p wd-sm-200 wd-lg-250 mg-b-15">
                    {img}
                </div>
                <h4 className={"tx-color-01 tx-12 mg-xl-b-5 " + style}>{data}</h4>
                {this.props.subText}
            </div>
        )
    }
    // render(){
    //     var data=this.props.data==''||this.props.data==null?"No Data Found":this.props.data;
    //     return (<div style={NoDataFoundCSS} className='animated zoomIn'>
    //                 <h1>{data}</h1>
    //                 <>{this.props.subText}</>
    //             </div>);
    // }
}